import { Star, StarHalf, StarBorder } from "@mui/icons-material";
import { Box } from "@mui/material";
import useWindowSize from "../../hooks/useWindowSize";

const StarDisplay = ({ rating }) => {
  const size = useWindowSize();
  const { width } = size;

  return (
    <div className="d-flex" style={{ lineHeight: "10px" }}>
      {Array.from({ length: 5 }).map((_, index) => {
        const starValue = index + 1;
        return (
          <div
            key={index}
            className=""
            style={{
              color: "#FFCA28",
              fontSize: width >= 640 ? "1.4rem" : "1rem",
              marginX: "2px",
              lineHeight: "8px",
            }}
          >
            {rating >= starValue ? (
              <Star fontSize="inherit" />
            ) : rating >= starValue - 0.5 ? (
              <StarHalf fontSize="inherit" />
            ) : (
              <StarBorder fontSize="inherit" />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StarDisplay;
